import { useState, useCallback } from 'react'

const STORAGE_PREFIX = 'press_wizard_'
const SCHEMA_VERSION = 1
const TTL_MS = 7 * 24 * 60 * 60 * 1000 // 7 days

function getKey(matchId) {
  return `${STORAGE_PREFIX}${matchId}`
}

function loadState(matchId) {
  try {
    const raw = localStorage.getItem(getKey(matchId))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed._v !== SCHEMA_VERSION) return null
    if (parsed._ts && Date.now() - parsed._ts > TTL_MS) {
      localStorage.removeItem(getKey(matchId))
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export function useWizardPersistence(matchId) {
  const [savedState] = useState(() => loadState(matchId))

  const saveState = useCallback((partialState) => {
    if (!matchId) return
    try {
      const existing = loadState(matchId) || {}
      const merged = { ...existing, ...partialState, _v: SCHEMA_VERSION, _ts: Date.now() }
      localStorage.setItem(getKey(matchId), JSON.stringify(merged))
    } catch {
      // localStorage full or unavailable — silently ignore
    }
  }, [matchId])

  const clearState = useCallback(() => {
    if (!matchId) return
    try {
      localStorage.removeItem(getKey(matchId))
    } catch {
      // silently ignore
    }
  }, [matchId])

  return { savedState, saveState, clearState }
}
